import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';

import Dialog, { DialogContent } from 'material-ui/Dialog';

import ButtonBase from 'material-ui/ButtonBase';
import Typography from 'material-ui/Typography';

const styles = theme => ({
  paper: {
    maxWidth: 'unset',
  },
  dialogContent: {
    padding: '0 !important',
  },
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    paddingBottom: theme.spacing.unit * 2,
    borderBottom: '1px solid rgba(155,155,155,0.15)',
    '&:first-of-type': {
      borderTop: '1px solid rgba(155,155,155,0.15)',
    },
  },
  header: {
    width: '100%',
    minHeight: 48,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  error: {
    color: theme.palette.error['A400'],
  },
  flex: {
    flex: 1,
  },
  input: {
    width: '0.1px',
    height: '0.1px',
    opacity: '0',
    overflow: 'hidden',
    position: 'absolute',
    zIndex: -1,
  },
  button: {
    width: 280,
    minHeight: 186,
    textOverflow: 'ellipsis',
    whiteSpace: 'unset',
    cursor: 'pointer',
    //overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: 'auto',
    lineHeight: 0,
    fontSize: 0,
    '& > img': {
      width: '100%',
      height: 'auto',
    },
  },
  placeholder: {
    width: '100%',
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 3,
    textAlign: 'center',
    backgroundColor: theme.palette.common.faintBlack,
  },
});

class ImageWidget extends Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, formContext, schema, name, value } = this.props;
    const title = schema.title === undefined ? name : schema.title;
    const {
      imageFileExtension,
      imageOriginalPrefix,
      imagePath,
      imageThumbnailPrefix,
    } = formContext;

    const thumbnailUrl = !value
      ? null
      : `${imagePath}${imageThumbnailPrefix}${value}${imageFileExtension}`;

    const imageUrl = !value
      ? null
      : `${imagePath}${imageOriginalPrefix}${value}${imageFileExtension}`;

    const input = (
      <div className={classes.container}>
        <header className={classes.header}>
          <Typography>{title}</Typography>
          <div className={classes.flex} />
        </header>
        <ButtonBase
          component="div"
          focusRipple
          className={classes.button}
          onClick={this.handleClickOpen}
        >
          <div className={classes.image}>
            <img src={thumbnailUrl} alt="" />
          </div>
        </ButtonBase>
        <Dialog
          open={this.state.open}
          onRequestClose={this.handleRequestClose}
          classes={{
            paper: classes.paper,
          }}
        >
          <DialogContent className={classes.dialogContent}>
            <div className={classes.image}>
              <img src={imageUrl} alt="" />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );

    return input;
  }
}

ImageWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  formContext: PropTypes.object.isRequired,
  name: PropTypes.string,
  value: PropTypes.string,
  schema: PropTypes.object.isRequired,
  errorSchema: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  id: PropTypes.string,
  readonly: PropTypes.bool,
};

export default withStyles(styles)(ImageWidget);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/readonly/ImageWidget.js